export default __webpack_public_path__ + "static/media/Upload.d7b2becc.svg";